import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Workspaces/Images/Image/Blobs'
import { imageLayoutRoute, imageRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Routing'

export const imageBlobsRoute = createRoute({
  getParentRoute: () => imageRoute,
  path: StaticRouteParameter.BLOBS,
  loader: () => ({
    crumb: t('entity:content.image', { count: 2 }),
  }),
})

type ImageBlobsOverviewSearch = {
  query?: string
}

export const imageBlobsOverviewRoute = createRoute({
  getParentRoute: () => imageLayoutRoute,
  path: `${StaticRouteParameter.BLOBS}/`,
  component: Overview,
  validateSearch: (search: Record<string, unknown>): ImageBlobsOverviewSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    return result satisfies ImageBlobsOverviewSearch
  },
})
